<template>
  <section class="single-cat">
    <article>
      <div class="row clearfix">
        <h1>
          Circus and Physical Theatre
          <!-- <a href="javascript:;" data-table="category-trends-table" class="infotoggle inline tooltipstered">Click for more info</a> -->
        </h1>

        <div class="sixcol">
          <p>In 2025, <strong>Circus and Physical Theatre</strong> generated $64.7m in revenue and attracted over 0.7m attendances.</p>
          <p>Among all categories, <strong>Circus and Physical Theatre</strong> recorded the highest y-o-y growth in revenue of 159.6% (from $24.9m in 2024 to $64.7m in 2025) and attendance of 88.1% (from 0.4m in 2024 to 0.7m in 2025).</p>
          <p>The y-o-y increase in average ticket price by 40.3% (from $67.93 in 2024 to $95.32 in 2025) also contributed to the growth in revenue.</p>
          <p><strong>Circus and Physical Theatre</strong> contributed 1.9% of total industry revenue and 2.4% of total attendance in 2025, up from 0.7% and 1.2% respectively in 2024.</p>
          <p>This category can be variable depending on the presence or absence of major tours by international companies in any given year, particularly Cirque du Soleil.*</p>
        </div>
        <div class="sixcol last">
          <p>The significant growth in this category was primarily driven by the inclusion of data from <em>Cirque du Soleil's</em> national tour in 2025. Top events in 2025 included <em>Cirque Du Soleil: Corteo</em>, <em>Now You See Me Live</em>, <em>Blanc de Blanc Encore</em>, <em>Penn &amp; Teller</em> and <em>Cirque Alice</em>.</p>
          <p>In 2025, NSW, QLD and VIC generated the most revenue and attendance in this category. These three states together generated 78.3% of national <strong>Circus and Physical Theatre</strong> revenue and 80.8% of national attendance in 2025.</p>
          <p>In 2025, all states and territories except ACT, TAS and NT recorded y-o-y growth in both revenue and attendance.</p>
          <p>QLD recorded the highest y-o-y growth in revenue (516.9%) and in attendance (367.3%), driven by major performances such as <em>Cirque Du Soleil: Corteo</em>, <em>Blanc de Blanc Encore</em>, <em>Cirque Alice</em> and <em>Penn &amp; Teller</em>.</p>
          <p>SA recorded the second-highest y-o-y growth in revenue (299.5%) and in attendance (108.6%), driven by major performances such as <em>Cirque Du Soleil: Corteo</em>, <em>Silvers Circus</em> and <em>Cosentino - Decennium</em>.</p>
          <p>WA recorded the third-highest y-o-y growth in revenue (251.9%) and in attendance (76.7%), driven by performances such as <em>Cirque Du Soleil: Corteo</em>, <em>La Clique</em>, <em>Mystique</em> and <em>Circus Rio Carnival</em>.</p>
        </div>

        <p style="font-size: .8em;text-align: center;">*Cirque du Soleil's <em>Luzia</em> was presented in Australia in 2024; however, data for this event were not included in the 2024 report. In 2025, data for Cirque du Soleil’s <em>Corteo</em> has been included, which appears to be a major contributor to the significant growth observed in the Circus and Physical Theatre category in 2025.</p>
        <p style="font-size: .8em;text-align: center;">Note: Data for <strong>Circus and Physical Theatre</strong> performances that were presented as part of a multi-artform festival will be captured in <strong>Festivals (Multi-Category)</strong>.</p>
      </div>
    </article>

    <figure class="chart">
      <div class="row clearfix">
        <highcharts class="graphcontainer" :options="totalRevenueAttendance"></highcharts>
      </div>
    </figure>

    <figure id="classical-music-states" class="chart">
      <div class="row clearfix">
        <h1>State/Territory Breakdown</h1>

        <div class="chart-wrapper">
          <highcharts class="graphcontainer" :options="activeStateBreakdown"></highcharts>
          <div class="nb">NB: Numbers may not total 100.0% due to rounding.<br>Categories/States with zero or &lt;0.05% of revenue and/or attendance<br> may not be reflected in the pie chart.</div>
        </div>
      </div>
    </figure>

    <div class="row clearfix">
      <h2 id="download-btn">Download the Report</h2>
      <div class="execsumm" style="justify-content: center;">
        <a href="./pdf/2025/CIRCUS AND PHYSICAL THEATRE  Live Performance Industry in 2025.pdf" class="button fullreport pdf" target="_blank">
          Circus and Physical Theatre Infographic Report 2025 (PDF)
        </a>
      </div>
    </div>

    <div class="fullbg">
      <p class="caption">Photo: <em>Amazônia</em>, presented by Adelaide Fringe, Photo Credit: Razan Fakhouri</p>
    </div>
  </section>
</template>

<script>
/*eslint-disable */

export default {
  data() {
    return {
      totalRevenueAttendance: {
        chart: {
          backgroundColor: null,
        },
        title: {
          text: ''
        },
        xAxis: [{
          categories: ["2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
          labels: {
            style: {
              color: '#fff'
            }
          }
        }],
        yAxis: [{ // Primary yAxis
          min: 0,
          labels: {
            formatter: function () {
              if (this.value > 999) {
                return '$' + (this.value / 1000) + 'b'
              } else {
                return '$' + this.value + 'm'
              }
            },
            style: {
              color: '#fff'
            }
          },
          title: {
            text: 'Gross Revenue',
            style: {
              color: '#fff'
            }
          },
          opposite: true
        }, { // Secondary yAxis
          min: 0,
          labels: {
            formatter: function () {
              if (this.value < 1) {
                return (this.value * 1000) + 'k'
              } else {
                return this.value + 'm'
              }
            },
            style: {
              color: '#fff'
            }
          },
          title: {
            text: 'Total Attendance',
            style: {
              color: '#fff'
            }
          },
          opposite: false
        }],
        tooltip: {
          shared: true,
          formatter: function () {
            let revy, tooltipstring;
            let rev = this.points[0];
            let att = this.points[1];
            let atty = att.y + 'm';
            let chart = this.points[0].series.chart;
            let categories = chart.xAxis[0].categories;
            let index = 0;
            while (this.x !== categories[index]) {
              index++;
            }
            if (rev.y > 1000) {
              revy = '$' + (rev.y / 1000).toFixed(2) + 'b'
            } else {
              revy = '$' + rev.y.toFixed(3) + 'm'
            }
            if (att.y < 1) {
              atty = (att.y * 1000).toFixed(0) + 'k'
            } else {
              atty = att.y + 'm'
            }

            tooltipstring = this.x + '<br />';
            tooltipstring += '<span style="color:' + rev.series.color + '">•</span> Revenue: ' + revy + '<br />'
            tooltipstring += '<span style="color:' + att.series.color + '">•</span> Attendance: ' + atty + '<br />'
            return tooltipstring
          }
        },
        legend: {
          layout: 'vertical',
          align: 'center',
          verticalAlign: 'bottom',
          floating: false,
          backgroundColor: '#FFFFFF'
        },
        series: [{
          name: 'Revenue',
          type: 'column',
          data: [8.602, 9.9, 55.866, 54.043, 142.033, 46.095, 99.559, 73.439, 116.543, 23.41, 47.447, 22.693, 21.221, 22.724, 68.303, 24.913, 64.674],
          color: '#3a89eb'
        }, {
          name: 'Attendance',
          type: 'column',
          yAxis: 1,
          data: [0.198, 0.266, 0.729, 0.556, 1.286, 0.565, 0.975, 0.839, 1.165, 0.45, 0.639, 0.275, 0.272, 0.326, 0.698, 0.387, 0.727],
          color: '#d14967'
        }]
      },
      activeYear: 2025,
      stateBreakdowns: [
        {
          year: 2025,
          revenue: [
            ["NSW", 27.3],
            ["VIC", 24.6],
            ["QLD", 26.4],
            ["WA", 13.1],
            ["SA", 5.3],
            ["ACT", 0.9],
            ["TAS", 2.2],
            ["NT", 0.2],
          ],
          attendance: [
            ["NSW", 26.2],
            ["VIC", 26.2],
            ["QLD", 28.4],
            ["WA", 10.7],
            ["SA", 4.6],
            ["ACT", 1.3],
            ["TAS", 2.4],
            ["NT", 0.3],
          ]
        }
      ],
    }
  },
  mounted() {
    window.scrollTo(0, 0)
  },
  computed: {
    activeStateBreakdown() {
      const self = this

      for (let i = 0; i < self.stateBreakdowns.length; i++) {
        const stateBreakdown = self.stateBreakdowns[i]
        if (stateBreakdown.year === self.activeYear) {
          return {
            chart: {
              type: 'pie',
              backgroundColor: 'transparent'
            },
            title: {
              text: ''
            },
            subtitle: {
              text: ''
            },
            plotOptions: {
              series: {
                states: {
                  inactive: {
                    opacity: 1
                  }
                }
              },
              pie: {
                shadow: false,
                center: ['50%', '50%'],
                dataLabels: {
                  enabled: true,
                  style: {
                    fontWeight: 'bold',
                    color: 'white',
                    textShadow: '0px 1px 2px black'
                  }
                },
                point: {
                  events: {
                    legendItemClick: e => {
                      e.preventDefault();
                      return false;
                    }
                  }
                }
              }
            },
            legend: {
              align: 'right',
              layout: 'vertical',
              verticalAlign: 'middle',
              itemMarginBottom: 10,
              itemStyle: {
                color: '#fff'
              },
              itemHoverStyle: {
                color: '#fff'
              }
            },
            tooltip: {
              valueSuffix: '%',
              valueDecimals: 1
            },
            series: [
              {
                name: 'Attendance Share',
                data: stateBreakdown.attendance,
                size: '68%',
                innerSize: '40%',
                borderColor: 'none',
                borderWidth: 1,
                slicedOffset: 30,
                showInLegend: true,
                dataLabels: {
                  color: '#000',
                  style: {
                    textShadow: 'none',
                  },
                  formatter: function () {
                    if (this.y > 3) {
                      return this.y.toFixed(1) + '% '
                    }
                  },
                  distance: -28
                }
              },
              {
                name: 'Revenue Share',
                data: stateBreakdown.revenue,
                size: '100%',
                innerSize: '70%',
                borderColor: 'transparent',
                borderWidth: 1,
                dataLabels: {
                  color: '#000',
                  style: {
                    textShadow: 'none',
                  },
                  formatter: function () {
                    if (this.y > 3) {
                      return this.y.toFixed(1) + '% '
                    }
                  },
                  distance: -32
                }
              }
            ],
            colors: [
              '#f66262',
              '#f2914a',
              '#5fa62b',
              '#6598d3',
              '#594ebb',
              '#bc56c3',
              '#c3567f',
              '#edc055'
            ]
          }
        }
      }

      return false
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
.single-cat {
  background-image: url("~@/assets/img/2025/20-Circus-+-Physical-Theatre-Amazônia_Gluttony-Rymill-Park-_-Razan-Fakhouri-2025-(381).jpg");
}

.chart-wrapper {
  position: relative;

  .nb {
    position: absolute;
    bottom: 0;
    right: 0;
    color: #fff;
    font-style: italic;
    font-size: 12px;
  }
}
</style>
